import * as api from '@sloyd/api';
import { actions, idbSaveState, selectors } from '@sloyd/store-base';
import { call, delay, put, select, takeEvery } from 'saga-ts';
import { getJson, invokeEvent, isMobile, l } from 'shared-base';
import { Json } from '../types';
import { parsePath } from '../utils/path';
import { filterOutV1 } from '../utils/projects';
import { customEventChannel } from './channels/channel.customEvent';

export function* onReady() {
  try {
    yield delay(50);

    yield put(
      actions.appState.patch({
        isLoadingFresh: false,
        isLoading: false,
        isDataReady: true,
      })
    );

    yield put({ type: 'DATA_READY' });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
// Fetch data from multiple API endpoints
export function* fetchAll(ev: any): Generator<any, void, any> {
  try {
    yield delay(50);

    const { data } = ev;
    const { token } = data;

    l('api|fetchAll');

    const isSlimVersion = yield select(selectors.base.$isSlimVersion);

    if (isSlimVersion) {
      yield call(onReady);
    }

    yield put(actions.appState.patch({ isLoadingFresh: true }));
    // Set the API token

    api.setToken(token);

    // TODO: remove
    // api.settings.bootstrap();

    // Prepare promises for parallel API calls
    const promises = [
      api.palettes.getAll(),
      api.generators.getAll(),
      api.packs.getAll(),
      api.materials.getAll(),
      api.projects.getAll(),
      // api.user.getSettings(),
    ];

    console.time('fetchAll');
    // Execute all API calls in parallel
    const res = yield Promise.all(promises);

    console.timeEnd('fetchAll');

    const palettes = res[0].data as Json;
    const generators = res[1].data as Json;
    const assetPacks = res[2].data as Json;
    const materials = res[3].data as IMaterials;
    const projects = res[4].data as Json;
    // const settings = res[5].data as ISettings;

    const playground = getJson('playground');
    if (playground) {
      projects.play = {
        id: 'play',
        name: 'Playground',
        ...playground,
      };
    }

    idbSaveState({
      // projects,
      palettes,
      generators,
      assetPacks,
      // settings,
      materials,
    });

    yield put(actions.projects.setAll(filterOutV1(projects)));
    yield put(actions.palettes.setAll(palettes));
    yield put(actions.assetPacks.setAll(assetPacks));
    yield put(actions.generators.setAll(generators));
    yield put(actions.allMaterials.setAll(materials));
    // yield put(actions.settings.patch(settings));

    // patchJson('SETTINGS', settings);

    const p = parsePath();
    if (p.projectId) {
      console.time('getProject');
      // yield call(getProject, p.projectId);
      console.timeEnd('getProject');
    }

    yield call(onReady);
  } catch (err) {
    console.log('err =>', err);
    invokeEvent('sentry', { err });
  }
}

export function* getProject(projectId: string) {
  try {
    return;
    const res = yield api.projects.get(projectId);
    const { data } = res;
    yield put(actions.projects.set(data.id, data));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

// Root saga
export function* root(): Generator<any, void, any> {
  if (isMobile()) return;
  l('saga|saga.api listening for AUTH_COMPLETED custom event');
  const channel = customEventChannel('AUTH_COMPLETED');
  yield takeEvery(channel, fetchAll);
}

// Export saga
export const saga = {
  id: 'sloyd.api',
  type: 'bootstrap',
  root,
  trigger: {},
};
